import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { ref, computed } from 'vue'
import { ChanceModifiesParams } from '@/typings/api/yuntuSales'
import { chanceModifiesTypeEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { chanceModifies } from '@/api/yuntuSales/analysis'
import { formatAmount } from '@/utils/format'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'


const __default__ = { name: 'DcCosLbuChanceModifies' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const searchFrom = ref<ChanceModifiesParams>({})
const columns = computed(() => [
  {
    title: '商机ID',
    dataIndex: 'chanceId',
    fixed: 'left',
    width: 150
  },
  {
    title: '客户名称',
    dataIndex: 'customerName'
  },
  {
    title: '客户代码',
    dataIndex: 'tmsCode'
  },
  {
    title: '操作人',
    dataIndex: 'createBy'
  },
  {
    title: '操作时间',
    dataIndex: 'createTime'
  },
  {
    title: '变动类型',
    dataIndex: 'changeType',
    dicData: chanceModifiesTypeEnum
  },
  {
    title: '变动前',
    dataIndex: 'beforeData',
    type: 'amount'
  },
  {
    title: '变动后',
    dataIndex: 'afterData',
    type: 'amount'
  }
])
const fetch = (params: ChanceModifiesParams, callBack: (res: any) => void) => {
  chanceModifies({
    ...params
  }).then((res) => {
    callBack(res)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            columns: columns.value,
            search: searchFrom.value,
            "onUpdate:search": _cache[8] || (_cache[8] = ($event: any) => ((searchFrom).value = $event)),
            onFetch: fetch,
            tableId: "lbuChanceModifies"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: searchFrom.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.value.customerName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.tmsCode,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchFrom.value.tmsCode) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "商机ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.chanceId,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.value.chanceId) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "变动类型" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: searchFrom.value.changeType,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom.value.changeType) = $event)),
                        placeholder: "请选择",
                        allowClear: "",
                        options: _unref(chanceModifiesTypeEnum)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "createBy",
                    label: "操作人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: searchFrom.value.createBy,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((searchFrom.value.createBy) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "createTime",
                    label: "操作时间"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: searchFrom.value.createStartTime,
                        "onUpdate:startTime": _cache[5] || (_cache[5] = ($event: any) => ((searchFrom.value.createStartTime) = $event)),
                        endTime: searchFrom.value.createEndTime,
                        "onUpdate:endTime": _cache[6] || (_cache[6] = ($event: any) => ((searchFrom.value.createEndTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "员工区域" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_lbu",
                        ids: searchFrom.value.employeeRegionList,
                        "onUpdate:ids": _cache[7] || (_cache[7] = ($event: any) => ((searchFrom.value.employeeRegionList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_lbu",
                taskType: "330",
                search: searchFrom.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'lbu_chanceModifies_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, text }) => [
              (column.type === 'amount')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(formatAmount)(text)), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})